import image from "../assets/img/2024_f35_best_photos_6_16x9.jpg"

import React from "react";
import { Helmet } from "react-helmet-async";
export default function PrivacyPolicyPage() {
  return (
    <section className="section container" style={{ paddingTop: "8rem" }}>
      <h1 className="section__title section__title-gradient">Privacy Policy</h1>
<img src={image} className="img-top"/>

      <div style={{ lineHeight: "2rem" }}>
        <p>
          <strong>Last updated:</strong> 2025-12-28
        </p>

        <h2 style={{ marginTop: "2rem" }}>1) Introduction</h2>
        <p>
          Topgun Aviation Academy (“Topgun”, “we”, “our”) respects your privacy and
          is committed to protecting it. [web:259]
        </p>
        <p>
          This Privacy Policy explains what information we collect, how we use it,
          and the choices you have when using our mobile application and related
          website pages. [web:259]
        </p>

        <h2 style={{ marginTop: "2rem" }}>2) Information We Collect</h2>
        <p>
          We collect information you provide directly and information collected
          automatically when you use the app. [web:273]
        </p>
        <ul>
          <li>
            <strong>Account / Profile data:</strong> such as email/username and
            profile details you submit when creating an account.
          </li>
          <li>
            <strong>User content:</strong> ratings, comments, favorites, and other
            content you choose to submit.
          </li>
          <li>
            <strong>Analytics data (Firebase Analytics):</strong> we use Firebase
            Analytics to understand app usage and improve the experience; this may
            involve collection of device/app identifiers and usage events. [web:279][web:280]
          </li>
        </ul>

        <h2 style={{ marginTop: "2rem" }}>3) How We Use Your Information</h2>
        <ul>
          <li>To create and maintain your account and provide core features.</li>
          <li>To operate community features such as comments, ratings, and favorites.</li>
          <li>
            To analyze usage, troubleshoot issues, and improve performance and
            product quality (including via Firebase Analytics). [web:279]
          </li>
          <li>To respond to support requests and communicate service updates.</li>
        </ul>

        <h2 style={{ marginTop: "2rem" }}>4) Sharing of Information</h2>
        <p>
          We do not sell your personal information. [web:273]
        </p>
        <p>
          We may share information with service providers that help us operate the
          Service (for example, analytics providers such as Google/Firebase) only
          to provide and improve the Service. [web:279][web:273]
        </p>

        <h2 style={{ marginTop: "2rem" }}>5) Data Retention</h2>
        <p>
          We retain personal information only as long as necessary to provide the
          Service, comply with legal obligations, or resolve disputes, then delete
          or anonymize it where feasible. [web:273]
        </p>

        <h2 style={{ marginTop: "2rem" }}>6) Your Choices</h2>
        <ul>
          <li>
            <strong>Account information:</strong> you can update certain profile
            information inside the app (if available).
          </li>
          <li>
            <strong>Deletion requests:</strong> you may request deletion of your
            account and associated personal data by contacting us using the details
            below. [web:273]
          </li>
        </ul>

        <h2 style={{ marginTop: "2rem" }}>7) Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational safeguards
          to protect information. However, no method of transmission or storage is
          100% secure. [web:273]
        </p>

        <h2 style={{ marginTop: "2rem" }}>8) Children’s Privacy</h2>
        <p>
          The Service is not intended for children under the age required by
          applicable law for consent. If you believe a child provided personal
          information, contact us for removal. [web:273]
        </p>

        <h2 style={{ marginTop: "2rem" }}>9) Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time and will update the
          “Last updated” date accordingly. [web:259]
        </p>

        <h2 style={{ marginTop: "2rem" }}>10) Contact Us</h2>
        <p>
          For privacy questions or data requests:
        </p>
        <ul>
          <li><strong>Email:</strong> support@yourdomain.com</li>
          <li><strong>Developer/Company:</strong> Topgun</li>
        </ul>
      </div>
    </section>
  );
}
